import { render, staticRenderFns } from "./DatafonoDevolucionComponent.vue?vue&type=template&id=54262a75"
import script from "./DatafonoDevolucionComponent.vue?vue&type=script&lang=js"
export * from "./DatafonoDevolucionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports